module.exports = __webpack_public_path__ + "img/list23.8db4576b.jpeg";